module.exports = __webpack_public_path__ + "static/media/profile_rounded.44848706.png";